import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  container: {
    [theme.breakpoints.up('lg')]: {
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(8),
    },
  },
  headerActionButton: {
    marginRight: theme.spacing(2),
  },
}))
